import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import _ from "lodash";

import UserApi from "../../../api/user-api";

import { Container } from "components/ui-kit/styled-templates";
import Table from "components/ui-kit/table";

import UniversityApi from "api/university-api";

import { objectToQS } from "services/common-service";

import useBodyBackground from "hooks/useBodyBackground";
import { useStorageListener } from "hooks/useStorage";

// { value: `cultural`, label: `Культурно-познавательные` },
// { value: `scientific`, label: `Научно-популярные` },
// { value: `proforientation`, label: `Профориентационные` },

function getEventsLabel(allEvents, uniId) {
    let uniEvents = allEvents.filter((x) => x.universityId == uniId);
    let cN = uniEvents.filter((x) => x?.details?.type == "cultural").length;
    let sN = uniEvents.filter((x) => x?.details?.type == "scientific").length;
    let pN = uniEvents.filter((x) => x?.details?.type == "proforientation").length;
    return `${+cN + +sN + +pN} (${cN}, ${sN}, ${pN})`;
}

const UniversitiesDashboardPage = () => {
    const { t } = useTranslation();

    const navigate = useNavigate();
    useBodyBackground("white");

    const university = useStorageListener(`universities`, {});
    const dormitories = useStorageListener(`dormitories`, []);
    const events = useStorageListener(`events`, {});
    console.log("UniversitiesDashboardPage: events = ", events);
    let eventsList = Object.values(events);
    console.log("UniversitiesDashboardPage: eventsList = ", eventsList);

    // @ts-ignore
    useEffect(UniversityApi.getAllUniversitiesData, []);
    return (
        <Container extra="padding-top: 10px; align-items: flex-start;">
            <h2>{t("fjquvpsh6zq")}</h2>
            <Table
                name="admin-uni-dashboard"
                withPagination={false}
                useBackendProcessing={false}
                rows={_.values(university)?.map?.((uni) => ({
                    ...uni,
                    dormitoriesNumber: `${_.values(dormitories)?.filter?.((i) => i?.universityId === uni?.id)?.length}`,
                    eventsLabel: `${getEventsLabel(eventsList, uni?.id)}`,
                    number:
                        _.values(university)
                            ?.map?.((i) => i?.createdTimestamp)
                            ?.indexOf?.(uni?.createdTimestamp) + 1,
                }))}
                sortable={true}
                columns={[
                    { name: `number`, label: `№`, showIndexOnClick: true },
                    { name: `id`, label: `ID` },
                    {
                        name: `details.name`,
                        label: `Название`,
                        extra: `flex: 4;`,
                        onCellClick: ({ row }) => navigate(`/university/${row?.id}`),
                    },
                    { name: `dormitoriesNumber`, label: `Кол-во общежитий` },
                    { name: `eventsLabel`, label: `События (К,Н,П)` },
                    {
                        name: `link`,
                        label: ``,
                        transform: (d) => `Открыть`,
                        onCellClick: ({ row }) => navigate(`/dormitories${objectToQS({ universityId: row?.id })}`),
                        extra: `justify-content: flex-end;`,
                        sortable: false,
                    },
                    {
                        name: `hideFromAll`,
                        label: ``,
                        transform: ({ row }) => (row?.hideFromAll ? 'y-y' : '-'),
                        cell: {
                            type: "icon",
                            className: "w-6 h-6 cursor-pointer",
                            srcFunction:  (({ row }) => (row?.hideFromAll ? 'eye-x' : ''))
                        }
                    },
                    {
                        name: `link`,
                        label: ``,
                        transform: (d) => `Войти`,
                        onCellClick: ({ row }) => {
                            UserApi.getUniToken(row?.id).then((token) => {
                                // window.alert(token);
                                window.open(`https://stud.simbox.online/?auth_token=${token}`, "_blank").focus();
                            });
                            // navigate(`/dormitories${objectToQS({ universityId: row?.id })}`)
                        },
                        extra: `justify-content: flex-end;`,
                        sortable: false,
                    },
                ]}
            />
        </Container>
    );
};

export default UniversitiesDashboardPage;
